import React, { useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";

export default function ButtonMyinfo() {

    const basePath = process.env.MIX_REACT_BASEPATH || "";


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const handleRetrieve = async () => {

        setLoading(true);
        setError("");

        try {
            const { data } = await axios.get(`${basePath}/singpass`, { params: {
                myInfoType: 'myinfo'
            }});


            if (data?.status === "success" && data.authoriseUrl) {

                // set cookie
                document.cookie = `code_verifier=${data.codeVerifier}; path=/; max-age=${60 * 1};`;
                document.cookie = `nonce=${data.nonce}; path=/; max-age=${60 * 1};`;

                // redirect
                window.location.href = data.authoriseUrl;
            }
            else {
                setError("Unexpected response from server.");
            }
        }
        catch (err) {
            console.error(err);
            setError("Failed to connect to Singpass. Please try again.");
        }
        finally {
            setLoading(false);
        }
    };

    return (

        <div className="button">
            <Button onClick={handleRetrieve} variant="danger" disabled={loading}>{loading ? "Redirecting to Singpass..." : "Retrieve Myinfo with Singpass"}</Button>
            {error && <p className="mt-1 text-warning">{error}</p>}
        </div>

    );
}
